import {
  Button,
  Divider,
  Logo,
  Typography,
} from '@data-products-and-ai/react-components';
import { AzureLoginButton } from '@/pages/Login/components';

import '@/pages/Login/styles.scss';

export const LoginPage = () => {
  const handleEmail = () => {
    const mail = document.createElement('a');
    mail.href = `mailto:miquel.rius-carmona@siemens-energy.com?subject=Snowflake Ingestor - Request access`;
    mail.click();
    mail.remove();
  };

  return (
    <div className="login-page">
      <div className="login-page__form">
        <div className="login-page__form-content">
          <Logo background="light" size="medium" />
          <Typography>SEIR/Millwright Safety Model</Typography>
          <div className="login-page__form-content-login">
            <AzureLoginButton />
          </div>
        </div>
        <div className="login-page__form-additional">
          <Divider />
          <Button type="link" allCaps={false} onClick={handleEmail}>
            Request Access
          </Button>
        </div>
      </div>
    </div>
  );
};
